import React, { useRef, useEffect } from 'react';

import styled from 'styled-components';

export default function LockerDivisionInput(props) {
	const { value, setValue, onCancel } = props;
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

	// 입력값 변경 시 너비 자동 조정 //
	useEffect(() => {
    if (inputRef.current) {
      const length = value.length > 0 ? value.length : 1;
      const newWidth = Math.min(300, Math.max(40, length * 11));
      inputRef.current.style.width = `${newWidth}px`;
    }
	}, [value]);

  // 입력 필드 포커스 설정 //
  useEffect(() => {
    if (inputRef !== null) {
      setTimeout((inputRef.current.focus()), 250);
    }
  }, [inputRef])

  // 외부 클릭 시 취소 처리 //
  useEffect(() => {
    function handleClickOutside(e) {
      if (e.target.closest('[data-locker-add-button]')) return;

      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        if (onCancel) onCancel();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onCancel])

	function handleChange(e) {
    setValue(e.target.value);
	}

	return (
    <TopLevelWrapper ref={wrapperRef}>
      <Input
        ref={inputRef}
        value={value}
        onChange={handleChange}
      />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;
`;

const Input = styled.input`
  text-align: center;
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	padding: 5px 12px;

	outline: none;
  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background-color: #FFFFFF;

  min-width: 40px;
  max-width: 300px;
  width: auto;

	::placeholder {
		color: #CBCBCB;
	}
`;
